// /share: where Android's share sheet lands (the manifest's share_target, taken by the service worker). Reads the share
// once (share.ts), holds it, and opens the server I was last in, where "Send to…" asks which conversation it goes to.
// Signed out: sign in first (the share stays kept until then). Nothing kept: just open the app.
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "../session.tsx";
import { lastServer } from "../lastVisit.ts";
import { holdShare, readShareOnce } from "../share.ts";

export function Share() {
  const { me } = useSession();
  const [to, setTo] = useState<string | null>(null);
  useEffect(() => {
    if (!me) return;
    let live = true;
    void readShareOnce().then((share) => {
      if (!live) return;
      const server = me.servers.find((s) => s.id === lastServer()) ?? me.servers[0];
      if (share && server) holdShare(share);
      setTo(server ? `/s/${server.id}` : "/");
    });
    return () => {
      live = false;
    };
  // Who I am, not the session object: it's replaced when the session refreshes, and the share is read only once.
  }, [me?.id]);
  if (me === null) return <Navigate to="/login?next=%2Fshare" replace />;
  return to ? <Navigate to={to} replace /> : null;
}
